import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./PageHero.css";

export default function PageHero({ eyebrow, title, subtitle }) {
  const lines = Array.isArray(title) ? title : [title];

  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".page-hero__title span, .page-hero__subtitle, .eyebrow"), {
      y: 24,
      opacity: 0,
      duration: 0.7,
      stagger: 0.08,
      ease: "power3.out",
    });
  }, []);

  return (
    <section className="page-hero" ref={sectionRef}>
      <div className="page-hero__disc" aria-hidden="true" />
      <div className="container">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="page-hero__title">
          {lines.map((line, i) => (
            <span key={i}>{line}</span>
          ))}
        </h1>
        {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
      </div>
    </section>
  );
}
